import React, { useState, useEffect } from 'react';
import { errorMsg, homeUrl, isBlankOrNullString, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import {  getUIState, isPremiumUser, refreshHomePageDetails } from '../login/auth_utils';
import { LockIcon, SearchIcon, UnlockIcon } from '../ui_components/common_icons';
import { GenericPremiumOneLineComponent, PremiumOneLineComponent } from '../premium/premium_discounts';
import { AIInterviewerLinkHomePage, PreparationLinkHomePage } from '../preparation_plans/preparation_home_page_link';
import { DoNotLikeCodeZymFormButton } from '../customer_support/do_not_like_codezym';
import { MockInterviewTopmateHomePage } from './mock_interview';
import { LinkUI, LinkUIBasic, LinkUIBlueBold } from '../ui_components/common_links';
import { CodeZymPremiumWithMock } from '../premium/premium_with_mock_interview';
import { BRR, ExpandCloseTab, SPACE, SPACE2 } from '../ui_components/common_ui_components'
import { BulkSubscriptionOneLine } from '../premium/bulk_subscription';
import { QuestionDifficultyTagUI, TagsListUI, TagUITablet } from './tags_list_ui';
import { useParams } from 'react-router-dom';
import { addCompanyUrlsInPlace } from './question_utils';
import { NavbarTop } from '../ui_components/navbar_top';
import { ConnectAndBook } from '../ui_components/connect_and_book';
import {  ReadMoreButtonHeight } from '../ui_components/read_more_button';
import "./company_questions.css"
import { DesktopQuestionsTable, MobileQuestionsList } from './question_row_ui';
import { FooterSection } from '../ui_components/footer';

function CompanyQuestionsTable() {
  const [questionList, setQuestionList] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [title, setTitle] = useState(' ')
  const [description, setDescription] = useState('')
  const [imageUrl, setImageUrl] = useState('')

  // this query will be used to filter questions list
  const [query, setQuery] = useState("")

  const isPremium = isPremiumUser();
  const uiState = getUIState()
  console.log("going to build all questions table : ")

  const { companyCode } = useParams();

  console.log("company code " + companyCode)

  if (isBlankOrNullString(companyCode)) window.location.href = "/"

  const updateSearchQuery = (query) => {
    setQuery(query)
  }

  /** returns true then we display question else we don't */
  const showQuestion = (q, question) => {
    const qq = (q ?? "").trim().toLowerCase();
    if (!qq) return true;

    const heading = "" + question.questionId + ". " + (question.heading ?? "") +
      " " + (question.designPatterns ?? "")

    const inHeading = heading.toLowerCase().includes(qq);

    const inCompanies = (question.companies ?? []).some(
      (c) =>
        (c?.name ?? "").toLowerCase().includes(qq) ||
        (c?.code ?? "").toLowerCase().includes(qq)
    );

    return inHeading || inCompanies;
  };

  useEffect(() => {
    console.log("fetching the all questions list");

    fetch(homeUrl() + "questionsApi/companyQuestions/" + companyCode, {
      method: "GET"
    })
      .then((response) => response.json())
      .then((data) => {
        if (success(data.status)) {
          console.log(data.metadata?.title)
          console.log(data.metadata?.descriptionHTML)

          addCompanyUrlsInPlace(data.questions)

          setQuestionList(data.questions)

          const tt = data.metadata?.title || ("" + companyCode + " Interview Questions")
          setTitle(tt)

          document.title = tt.replaceAll("<br />", "")

          setDescription(data.metadata?.descriptionHTML || "")
          setImageUrl(data.metadata?.imageUrl || "")

          if (data.questions && data.questions.length > 0) {
            for (const company of data.questions[0].companies) {
              if (company.code == companyCode.trim()) {
                setCompanyName(company.name)
              }
            }
          }
        }
        else {
          setError(data.message || "Error in fetching questions, please try again")
        }

        console.log("response received " + data.questions.length + " questions")
        console.log(data);

        refreshHomePageDetails()
      })
      .catch((error) => {
        console.log("error occurred in fetching all questions " + JSON.stringify(error));
        setError(errorMsg())
      });
  }, []); // empty bracket means there are no dependencies which will make useEffect re run

  const filteredQuestions = questionList.filter((row) => showQuestion(query, row));

  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-hidden bg-gradient-to-b from-white via-sky-50/40 to-white">
      <NavbarTop />

      <main className="mx-auto mt-20 w-full  px-4 sm:px-6 lg:px-8
       flex flex-col items-center justify-center">

        {imageUrl && (
        <div className=" w-full max-w-6xl rounded-3xl border border-slate-100 bg-white shadow-sm">
          <img
            src={imageUrl}
            alt={title}
            className="h-auto w-full rounded-3xl object-contain"
          />
        </div>
      )}

        {title && (
          <section className="pt-8">
            <h1
              className="max-w-6xl text-2xl  text-center  
              font-extrabold leading-tight 
              tracking-tight text-slate-950 sm:text-4xl md:text-3xl"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </section>
        )}

        {description && (
          <section className="mt-5 max-w-6xl text-base leading-7 text-slate-600 sm:text-lg">
            <ReadMoreButtonHeight text={description} collapsedHeight={90} />
          </section>
        )}

        <FrequentlyUpdateTextUI companyName={companyName} questionList={questionList} />

        {questionList.length > 0 &&
          <>
            <div className="mt-1 flex w-full bg-white px-4 md:px-5 
             items-center justify-center">
              <div className="relative flex w-full max-w-6xl  items-center justify-center">
                <span className="pointer-events-none absolute left-4 text-gray-400">
                  <SearchIcon />
                </span>

                <input
                  type="text"
                  value={query}
                  onChange={(e) => updateSearchQuery(e.target.value)}
                  placeholder={`Search by question number, title, design pattern etc`}
                  aria-label="Search by heading, design pattern or company"
                  className="w-full rounded-xl border border-gray-300
                   bg-white py-2 pl-12 pr-4 text-sm shadow-sm
                    placeholder:text-gray-400 focus:border-indigo-500 focus:outline-none"
                />
              </div>
            </div>

            <div id="questions-list" className="mt-4 w-full">
              <MobileQuestionsList
                questions={filteredQuestions}
                query={query}
                isPremium={isPremium}
              />

              <DesktopQuestionsTable
                questions={filteredQuestions}
                query={query}
                isPremium={isPremium}
              />
            </div>

            {filteredQuestions.length == 0 &&
              <div className="mt-6 rounded-2xl border border-slate-200 bg-white px-4 py-10 text-center text-sm font-medium text-slate-500 shadow-sm">
                No questions found for "{query}"
              </div>
            }
          </>
        }

        {!error && !message && questionList.length == 0 &&
          <div className="mt-14 text-center text-2xl font-bold text-blue-700">
            Loading all Questions. <br /> Please wait ...
          </div>
        }

        {!error && questionList.length == 0 &&
          <div className="mt-16 flex justify-center">
            <IndefiniteProgressBar />
          </div>
        }

        {error && error.length > 0 &&
          <div className="mt-10 text-center text-lg font-semibold text-red-700">
            {error} <br />
          </div>
        }

        {message && message.length > 0 && !error && error.length == 0 &&
          <div className="mt-10 text-center text-xl font-bold text-blue-700">
            {message} <br />
          </div>
        }

        <div className="mt-12">
          <ConnectAndBook />
        </div>
      </main>

      <div className="mt-12">
        <FooterSection />
      </div>
    </div>
  );
}


function removeAfterComma(text){
 if(text==null||!text||text.length==0) return ''

 // capitalize only if length >= 1
  if (text.length >= 1) {
    text = text.charAt(0).toUpperCase() + text.slice(1);
    // console.log(text+" "+text.length)
  }
 let index=text.indexOf(',')
 if(index<0) return text
 text= text.substring(0, index)



 return text;
}

/**
 * shows below text 
 * Below list is updated frequently. Reflects top {companyName} questions in last 6 months
 */
function FrequentlyUpdateTextUI({ companyName, questionList }) {
  if (!questionList || questionList.length < 10) return (<div></div>)

  return (
    <div className="my-5">
      <div className="flex items-center justify-center gap-3 rounded-2xl border border-sky-200 bg-sky-50/70 px-5 py-2 text-sm text-slate-700 shadow-sm">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-500 text-xs font-bold text-white">
          i
        </span>

        <p className="m-0 font-medium">
          Below list is updated frequently. Reflects top {companyName} questions in last 6 months.
        </p>
      </div>
    </div>
  )
}

/**
 * shows below text 
 * Below list is updated frequently . Reflects top {companyName} questions in last 6 months
 */
function FrequentlyUpdateTextUIOld1({companyName, questionList}){
  if(!questionList || questionList.length<10) return (<div></div>)
  return (
    <div className='text-sm py-4 text-gray-500 italic text-center'>
       {//false &&
        <p>Below list is updated frequently . Reflects top {companyName} questions in last 6 months
          </p> }
        { false && 
          <p>
            We continuously update/rearrange below list.  <br />
        It always reflects Most Frequently asked {companyName} questions in last 6 months
          </p>
        }
    </div>
    
  )
}

export {CompanyQuestionsTable};

